import { AlertType } from '@aloft/toolkit-shared';

import toast from 'react-hot-toast';

import { syncAlertHoverPreview } from '../../modules/alerts/syncAlertHoverPreview.ts';
import { clearAlertsPanelAutoOpenedForNavBlock } from '../../redux/features/referenceBarUISlice.ts';
import { suppressAlertToasts } from '../../redux/features/uiSlice.ts';
import { store } from '../../redux/store.ts';
import { getAlertToastId } from './constants.ts';

const registeredAlertToastTypes = new Set<AlertType>();

export const registerAlertToast = (alertType: AlertType) => {
  registeredAlertToastTypes.add(alertType);
};

export const isAlertToastRegistered = (alertType: AlertType) =>
  registeredAlertToastTypes.has(alertType);

export const unregisterAlertToast = (alertType: AlertType) => {
  if (!registeredAlertToastTypes.delete(alertType)) return;
  toast.remove(getAlertToastId(alertType));
};

export const dismissAlertToastUI = () => {
  registeredAlertToastTypes.forEach((alertType) => {
    toast.remove(getAlertToastId(alertType));
  });
  registeredAlertToastTypes.clear();
};

export const dismissInactiveAlertToasts = (activeAlertTypes: ReadonlySet<AlertType>) => {
  [...registeredAlertToastTypes].forEach((alertType) => {
    if (!activeAlertTypes.has(alertType)) {
      unregisterAlertToast(alertType);
    }
  });
};

export const dismissAllToasts = () => {
  toast.dismiss();
};

export const suppressAlertToast = (alertType: AlertType) => {
  store.dispatch(suppressAlertToasts([alertType]));
  unregisterAlertToast(alertType);
};

export const dismissAlertToasts = () => {
  const alertTypes = [...registeredAlertToastTypes];
  if (alertTypes.length > 0) {
    store.dispatch(suppressAlertToasts(alertTypes));
  }
  store.dispatch(clearAlertsPanelAutoOpenedForNavBlock());
  syncAlertHoverPreview(store.dispatch, null);
  dismissAlertToastUI();
  toast.dismiss();
};
